<input type="checkbox" class="form-control" [(ngModel)]="selectedBoolean" />